var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "create-forms" } },
    [
      _vm.isCreateFormVisible
        ? _c("div", { staticClass: "container" }, [
            _c("h2", [_vm._v("Form Oluşturun")]),
            _vm._v(" "),
            _c("h4", [
              _vm._v(
                "Veri toplamaya başlamak için bir form oluşturun veya aktarın"
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "card-wrapper",
                on: { click: _vm.formBuilderOpen },
              },
              [_vm._m(0)]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formBuilder
        ? _c("FormBuilder", { attrs: { formId: _vm.formId } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "card-icon" }, [_vm._v("+")]),
        _vm._v(" "),
        _c("div", { staticClass: "card-title" }, [_vm._v("Sıfırdan Başla")]),
        _vm._v(" "),
        _c("div", { staticClass: "card-description" }, [
          _vm._v("Boş bir formla başlayın"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }